import { useQuery } from "@tanstack/react-query";
//components
import Container from "components/Container";
import RatingStars from "components/RatingStarts";
//hooks
import { axiosInstance } from "hooks/api/config";

export default function SupplierDirectoryPage() {
  const { data, isLoading } = useQuery({
    queryKey: ["suppliers"],
    queryFn: () => axiosInstance.get(`suppliers`),
  });

  return (
    <div>
      <div
        className="h-96 relative"
        style={{ backgroundImage: 'url("/hero.jpg")' }}
      >
        <div className="bg-black/40 absolute top-0 right-0 bottom-0 left-0" />
      </div>
      <Container className={""}>
        <div>
          <h1 className="text-2xl font-bold mt-4">Supplier Directory</h1>
          {!!isLoading && (
            <div className="flex justify-center items-center">
              <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-900"></div>
            </div>
          )}
          {!isLoading && (
            <div className="mt-8 flow-root">
              <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                  <table className="min-w-full divide-y divide-gray-300">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                        >
                          Name
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          Supplier Type
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          Business Type
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          Contact Name
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          Email
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          Phone
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          Rating
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {data?.data.map((supplier: any) => {
                        return (
                          <tr key={supplier.id}>
                            <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                              {supplier.supplier}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                              {supplier.supplier_type}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                              {supplier.business_type}
                            </td>
                            {supplier.supplier_type === "individual" && (
                              <>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  {supplier.individual_contact_full_name}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  {supplier.individual_contact_email}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  {supplier.individual_contact_phone}
                                </td>
                              </>
                            )}
                            {supplier.supplier_type === "corporate" && (
                              <>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  {supplier.company_contact_full_name}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  {supplier.company_contact_email}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  {supplier.company_contact_phone}
                                </td>
                              </>
                            )}
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                              <RatingStars rating={supplier.license_use || 4} />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
}
